import PubSub from "underpub-js";

var Banner = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-Banner',
	};

	$.extend(true, this.options, options);

};

Banner.prototype.init = function() {

	var self = this;

	// Expose the banner's height so full-height heros can fit under it
	const setHeight = () => document.documentElement.style.setProperty('--banner-height', `${self.options.$el.outerHeight()}px`);
	setHeight();
	PubSub.subscribe('Sitewide:resized', setHeight);

};

export default Banner;
